import { useContext } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
//import AutoComplete from "../FreightMaster/AutoComplete/AutoComplete";
import AutoComplete from "../../../Shared/AutosuggestV2/Autosuggestv2";
import classes from "./LocationMaster.module.css";
import MultiSelectWithCheckbox from "../../../Shared/MultiSelectCheckbox/MultiSelectCheckbox";
import { MyCompanyProfileContext } from "../../../../MyCompanyProfileContext";

function LocationInputForm({
  locationName,
  setLocationName,
  setorigin,
  locationAddress,
  setLocationAddress,
  locationType,
  setLocationType,
  generateCode,
  setGenerateCode,
  generateRandomCode,
  pinCode,
  setPinCode,
  customerName,
  setCustomerName,
  gstNo,
  setGstNo,
  openTime,
  setOpenTime,
  closeTime,
  setCloseTime,
  truckOptions,
  selectedTruck,
  setselectedTruck,
  haltingTime,
  handleHaltingtimeChange,
  errorMessage,
  currentFuelRate,
  setcurrentFuelRate,
  company_id,
  canedit,
  canAccess,
  canUpdate,
  checkActionPermission,
}) {
  const { companySettingData } = useContext(MyCompanyProfileContext);
  const isRestricted = canedit || !canUpdate;

  return (
    <>
      <div className={"col-md-3"}>
        <span style={{ fontWeight: "600" }}>Location<span className="required-field"> *</span></span>
        <label style={{ width: "100%", pointerEvents: isRestricted ? 'none' : 'auto' }}>
          <AutoComplete
            key={"Origin_Key"}
            value={
              origin
                ? {
                  value: origin?.location?.location || locationName,
                  label: origin?.location_name || locationName
                }
                : locationName
                  ? {
                    value: locationName,
                    label: locationName
                  }
                  : null
            }
            placeholder="Origin"
            className={classes["originn"]}
            onChange={(val) => setLocationName(val)}   // string
            onSelect={(obj) => setorigin(obj)}         // full object
            isDisabled={isRestricted}
          />
        </label>
      </div>
      <div className={"col-md-3"}>
        <div>
          <span style={{ fontWeight: "600" }}>Address</span>
          <label style={{ width: "100%" }}>
            <input
              type="text"
              onChange={(e) => setLocationAddress(e.target.value)}
              value={locationAddress}
              style={{ height: "37px" }}
              disabled={isRestricted}
            />
          </label>
        </div>
      </div>
      <div className={"col-md-2"}>
        <div>
          <span style={{ fontWeight: "600" }}>Location Type</span>
          <label style={{ width: "100%" }}>
            <select
              id="contract_tenure"
              value={locationType}
              className={`form-control`}
              style={{ height: "37px" }}
              onChange={(e) => setLocationType(e.target.value)}
              disabled={isRestricted}
            >
              <option value="Destination">Destination</option>
              <option value="Plant">Plant</option>
              <option value="Warehouse">Warehouse</option>
            </select>
          </label>
        </div>
      </div>
      <div className={"col-md-2"}>
        <div>
          <span style={{ fontWeight: "600" }}>Location Code</span>
          <label style={{ width: "100%" }}>
            <input
              type="name"
              onChange={(e) => setGenerateCode(e.target.value)}
              value={generateCode}
              style={{ height: "37px", width: "100px" }}
              disabled={isRestricted}
            />
            {!isRestricted && (
              <div
                onClick={() => generateRandomCode(6)}
                className={`${classes["txt-underline1"]}`}
              >
                click to auto generate code
              </div>
            )}
          </label>
        </div>
      </div>
      <div className={"col-md-2"}>
        <div>
          <span style={{ fontWeight: "600" }}>Pincode</span>
          <label style={{ width: "100%" }}>
            <input
              type="number"
              onChange={(e) => setPinCode(Number(e.target.value))}
              value={pinCode}
              style={{ height: "37px" }}
              disabled={isRestricted}
            />
          </label>
        </div>
      </div>
      <div className={"col-md-3"}>
        <span style={{ fontWeight: "600" }}>Customer Name</span>
        <label style={{ width: "100%" }}>
          <input
            type="text"
            onChange={(e) => setCustomerName(e.target.value)}
            value={customerName}
            style={{ height: "37px" }}
            disabled={isRestricted}
          />
        </label>
      </div>
      <div className={"col-md-3"}>
        <div>
          <span style={{ fontWeight: "600" }}>GST No</span>
          <label style={{ width: "100%" }}>
            <input
              type="text"
              onChange={(e) => setGstNo(e.target.value)}
              value={gstNo}
              style={{ height: "37px" }}
              disabled={isRestricted}
            />
          </label>
        </div>
      </div>
      <div className={"col-md-2"}>
        <div>
          <span style={{ fontWeight: "600" }}>Open Timing</span>
          <label style={{ width: "85%" }}>
            <DatePicker
              selected={openTime}
              onChange={(date) => setOpenTime(date)}
              showTimeSelect
              showTimeSelectOnly
              timeIntervals={60}
              dateFormat="h:mm aa"
              disabled={isRestricted}
            />
          </label>
        </div>
      </div>
      <div className={"col-md-2"}>
        <div>
          <span style={{ fontWeight: "600" }}>Close Timing</span>
          <label style={{ width: "85%" }}>
            <DatePicker
              selected={closeTime}
              onChange={(date) => setCloseTime(date)}
              showTimeSelect
              showTimeSelectOnly
              timeIntervals={60}
              dateFormat="h:mm aa"
              disabled={isRestricted}
            />
          </label>
        </div>
      </div>
      <div className={"col-md-2"}>
        <div>
          <span style={{ fontWeight: "600" }}>Trucks Available</span>
          <MultiSelectWithCheckbox
            options={truckOptions}
            value={selectedTruck}
            onChange={(e) => setselectedTruck(e)}
            disabled={isRestricted}
          />
        </div>
      </div>
      <div className={"col-md-3"}>
        <div>
          <span style={{ fontWeight: "600" }}>Halting Time:</span>
          <div className="p-1" style={{ position: "relative" }}>
            <input
              style={{ height: "37px" }}
              type="number"
              aria-label="Halting time input"
              name="number"
              value={haltingTime}
              onChange={handleHaltingtimeChange}
              disabled={isRestricted}
            />
            <span
              style={{
                position: "absolute",
                right: "4px",
                top: "5.75%",
                padding: "0.7rem",
              }}
              className="bg-light border-left "
            >
              Minutes
            </span>
          </div>
          <div style={{ position: "absolute", top: "85%", left: "0" }}>
            {errorMessage && (
              <div
                style={{
                  color: "red",
                  marginLeft: "2.5rem",
                }}
              >
                {errorMessage}
              </div>
            )}
          </div>
        </div>
      </div>
      <div className={"col-md-3"}>
        <div>
          <span style={{ fontWeight: "600" }}>
            Current Fuel Rate (
            {companySettingData?.default_currency?.default_currency?.cc ??
              "INR"}
            )
          </span>
          <label style={{ width: "100%" }}>
            <input
              type="number"
              onChange={(e) => setcurrentFuelRate(e.target.value)}
              value={currentFuelRate}
              placeholder=""
              style={{ height: "37px" }}
              disabled={isRestricted}
            />
          </label>
        </div>
      </div>
    </>
  );
}

export default LocationInputForm;
